module.exports = __webpack_public_path__ + "img/11088024_L.37cba5d4.png";